export default __webpack_public_path__ + "static/step-1-ee128313d9f3fcdb250fdc23ce46a892.webp";